import TaskDashboardImage from 'public/assets/img/task-dashboard.svg';
import TemplateSubmissionDashboard from 'public/assets/img/template-submission-dashboard.svg';
import LocationDashboard from 'public/assets/img/location-dashboard.svg';
import ScoreDashboard from 'public/assets/img/score-dashboard.svg';
export const dashboardImages = {
  0: TaskDashboardImage,
  1: TemplateSubmissionDashboard,
  2: LocationDashboard,
  3: ScoreDashboard,
};
